import { useEffect } from "react";

// Injects page-level SEO into <head>: title, description, canonical,
// Open Graph / Twitter cards and JSON-LD structured data blocks.
// Used per page; JSON-LD blocks are removed on unmount.
export const SEOHead = ({ title, description, path = "", image, jsonLd = [] }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = origin + path;
    const created = [];

    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
        created.push(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", image ? (image.startsWith("http") ? image : origin + image) : undefined);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
      created.push(canonical);
    }
    canonical.setAttribute("href", url);

    jsonLd.filter(Boolean).forEach((data) => {
      const el = document.createElement("script");
      el.setAttribute("type", "application/ld+json");
      el.dataset.seoManaged = "1";
      el.textContent = JSON.stringify(data);
      document.head.appendChild(el);
      created.push(el);
    });

    return () => {
      created.forEach((el) => el.parentNode && el.parentNode.removeChild(el));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, JSON.stringify(jsonLd)]);

  return null;
};
